// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
import { PAD_ITEM_TYPE } from 'app/config/pad_item';
const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_ITEM_FURNITURE';

const initialState = () => ({
  screenData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;

      const code = codeGeneretor();
      const type = PAD_ITEM_TYPE.FURNITURE;

      const padModelItemFurniture = {
        ...newData.data,
        code,
        type
      };

      const screenData = [...state.screenData, padModelItemFurniture];

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padModelItemFurnitureEdited = { ...newData.data, type: PAD_ITEM_TYPE.FURNITURE };

      const screenData = _.cloneDeep(state.screenData);

      const indexScreen = screenData.findIndex(
        padVisit => padVisit.code === padModelItemFurnitureEdited.code
      );
      screenData.splice(indexScreen, 1, padModelItemFurnitureEdited);

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padModelItemFurniture = { ...newData.data };

      const screenData = _.cloneDeep(state.screenData).filter(
        padVisit => padVisit.code !== padModelItemFurniture.code
      );

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
